module.exports = __webpack_public_path__ + "img/plus.1e365535.svg";